<!--
 * @Author: ken yang
 * @Date: 2023-02-07 18:14:33
 * @LastEditTime: 2023-03-02 14:17:13
 * @LastEditors: ken yang
 * @Description:
 * @FilePath: /uexch_pc/src/components/dialog/DiaAutoJump.vue
-->
<template>
  <Column class="DiaHeader position-r" x="sb" y="c">
    <Row>
      <Column class="" y="c">
        <slot name="title">
          <span class="title bold">{{ title }}</span>
        </slot>
        
      </Column>
      <IconSvg v-if="showClose" class="position-a right-0 c-info label-lg text-14px pointer close" name="icon-IconClose" @click="onClose" />
    </Row>
    <slot name="label">
      <span v-if="label" class="c-info m-t-4 label">{{ label }}</span>
    </slot>
  </Column>
</template>
<script setup>

const emit = defineEmits()
const props = defineProps({
  title: {},
  label: {},
  showClose: {
    default: true
  },
})

const onClose = () => {
  emit('close', false)
}

</script>

<style lang="scss">
.DiaHeader{

}
</style>
